import React from "react";
import "./CompareCollegeFaq.css";
import Faq_Accordian from "../Common_Component/Faq_Accordian/Faq_Accordian";

function CompareCollegeFaq() {
  return (
    <>
      <div className="CompareCollegeFaq">
        <div className="container">

            <p className='section_heading'>Frequently Asked Questions</p>
          <div className="row">
            <div className="col-md-12">
              <Faq_Accordian />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CompareCollegeFaq;
